import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿El presupuesto tiene costo?',
  answer: 'No. Los presupuestos son totalmente gratis.'
}, {
  question: '¿Trabajan con contrato?',
  answer: 'Sí. Podemos trabajar con contratos ante notaría para entregar mayor respaldo y claridad.'
}, {
  question: '¿Qué garantía entregan?',
  answer: 'Se ofrece garantía de 5 años después de la construcción, según el tipo de trabajo y condiciones acordadas.'
}, {
  question: '¿Puedo enviar fotos por WhatsApp?',
  answer: 'Sí. Puedes enviar fotos, medidas o detalles del proyecto para orientar mejor el presupuesto.'
}, {
  question: '¿Qué tipo de trabajos realizan?',
  answer: 'Construcción, remodelaciones, ampliaciones, terminaciones y mejoras generales, según evaluación del proyecto.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-14">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="max-w-3xl mx-auto" data-id="element-16">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-navy text-center mb-12" data-id="element-17">
            Preguntas frecuentes
          </motion.h2>

          <div className="space-y-4" data-id="element-18">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="border border-gray-200 rounded-2xl overflow-hidden" data-id="element-19">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-20">
                  <span className="font-semibold text-navy text-lg pr-8" data-id="element-21">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-6 h-6 text-orange shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-22" />
                </button>
                <AnimatePresence data-id="element-23">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-24">
                      <div className="p-6 pt-0 text-gray-600 border-t border-gray-100" data-id="element-25">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}